// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2245":"e5d5de17","3752":"15f1dabb","4846":"b1b19689","5636":"b1b19689","7442":"5bd9832e","9699":"e5d5de17","9721":"e5d5de17"}[chunkId] + ".chunk.css";
};